/** Tipos da tela Início (Home) — mobile */

export type PrestStatus = 'pronta' | 'concluida' | 'rascunho';

export interface HeroCopy {
  titleLine1: string;
  titleLine2: string;
  cta: string;
  ctaIcon: 'Rocket' | 'FileCheck' | 'Receipt';
  ctaDestino: 'prest' | 'lanc';
}

/** Para onde navegar quando o usuário clica numa pendência. */
export interface PendLink {
  to: '/m/lancamentos' | '/m/prestacao';
  search?: { filter?: 'pending' };
}

export interface PendItem {
  id: string;
  label: string;
  sub: string;
  /** Cor semântica do dot indicador */
  tone: 'block' | 'warn';
  /** Tela de detalhes pra onde o tap navega (com filtro pré-aplicado quando aplicável). */
  link: PendLink;
}

export interface HomeData {
  /** competência no formato YYYY-MM */
  competencia: string;
  prestStatus: PrestStatus;
  lancamentosCount: number;
  valorTotal: number;
  receitas: number;
  despesas: number;
  saldo: number;
  pendencias: PendItem[];
}

export const HERO_COPY: Record<PrestStatus, HeroCopy> = {
  pronta: {
    titleLine1: 'Sua prestação',
    titleLine2: 'está pronta.',
    cta: 'Iniciar automação',
    ctaIcon: 'Rocket',
    ctaDestino: 'prest',
  },
  concluida: {
    titleLine1: 'Prestação',
    titleLine2: 'enviada.',
    cta: 'Ver comprovante',
    ctaIcon: 'FileCheck',
    ctaDestino: 'prest',
  },
  rascunho: {
    titleLine1: 'Prestação',
    titleLine2: 'em rascunho.',
    cta: 'Continuar lançamentos',
    ctaIcon: 'Receipt',
    ctaDestino: 'lanc',
  },
};
